export function getFunnelSessionCode(): string {
  const key = 'sh_funnel_oturum_kodu';
  let code = localStorage.getItem(key);

  if (!code) {
    code = 'SH-' + new Date().getTime() + '-' + Math.random().toString(36).substring(2, 10);
    localStorage.setItem(key, code);
  }

  return code;
}